const BMC_BLOCKS = {
  KEY_PARTNERS: 'key_partners',
  COST_STRUCTURE: 'cost_structure',
  REVENUE_STREAMS: 'revenue_streams',
  KEY_RESOURCES: 'key_resources',
  KEY_ACTIVITIES: 'key_activities',
  KEY_PROPOSITIONS: 'key_propositions',
  CUSTOMER_RELATIONSHIPS: 'customer_relationships',
  CHANNELS: 'channels',
  CUSTOMER_SEGMENTS: 'customer_segments',
};

const BMC_BLOCKS_BY_STEPS_ORDER = [
  BMC_BLOCKS.CUSTOMER_SEGMENTS,
  BMC_BLOCKS.KEY_PROPOSITIONS,
  BMC_BLOCKS.CHANNELS,
  BMC_BLOCKS.CUSTOMER_RELATIONSHIPS,
  BMC_BLOCKS.REVENUE_STREAMS,
  BMC_BLOCKS.KEY_RESOURCES,
  BMC_BLOCKS.KEY_ACTIVITIES,
  BMC_BLOCKS.KEY_PARTNERS,
  BMC_BLOCKS.COST_STRUCTURE,
];

const BMC_STAGES = {
  OBSERVATIONAL: 'observational_suggests',
  FIRST_GROUP: 'user_first_group_suggests',
  FOCUS_GROUP: 'focus_group_suggests',
  FIRST_USER: 'first_user_suggests',
  KNOW_HOW: 'know_how_suggests',
  EARLY_ADOPTERS: 'early_adopters_suggests',
  FIRST_CLIENT: 'first_client_suggests',
  FREE: 'free_suggests',
};

// const BMC_STAGES_WITH_SUB_STAGES = {
//     OBSERVATIONAL: "observational_suggests",
//     OBSERVATIONAL_INTERVIEW: "observational_interview_suggests",
//     OBSERVATIONAL_PERSON: "observational_person_suggests",
//
//     FIRST_USER: "first_user_suggests",
//     FIRST_USER_INTERVIEW: "first_user_interview_suggests",
//     FIRST_USER_PERSON: "first_user_person_suggests",
//
//     FIRST_GROUP: "user_first_group_suggests",
//     FIRST_GROUP_INTERVIEW: "user_first_group_interview_suggests",
//     FIRST_GROUP_PERSON: "user_first_group_person_suggests",
//
//     FOCUS_GROUP: "focus_group_suggests",
//     FOCUS_GROUP_INTERVIEW: "focus_group_interview_suggests",
//     FOCUS_GROUP_PERSON: "focus_group_person_suggests",
//
//     KNOW_HOW: "know_how_suggests",
//     KNOW_HOW_INTERVIEW: "know_how_interview_suggests",
//     KNOW_HOW_PERSON: "know_how_person_suggests",
//
//     EARLY_ADOPTERS: "early_adopters_suggests",
//     EARLY_ADOPTERS_INTERVIEW: "early_adopters_interview_suggests",
//     EARLY_ADOPTERS_PERSON: "early_adopters_person_suggests",
//
//     FIRST_CLIENT: "first_client_suggests",
//     FIRST_CLIENT_INTERVIEW: "first_client_interview_suggests",
//     FIRST_CLIENT_PERSON: "first_client_person_suggests",
//
//     FREE: "free_suggests",
// };

const BMC_STAGES_TO_INTEGER = {
  [BMC_STAGES.OBSERVATIONAL]: 0,
  [BMC_STAGES.FIRST_GROUP]: 1,
  [BMC_STAGES.FOCUS_GROUP]: 2,
  [BMC_STAGES.FIRST_USER]: 3,
  [BMC_STAGES.KNOW_HOW]: 4,
  [BMC_STAGES.EARLY_ADOPTERS]: 5,
  [BMC_STAGES.FIRST_CLIENT]: 6,
  [BMC_STAGES.FREE]: 7,
};

export {
  BMC_STAGES,
  BMC_STAGES_TO_INTEGER,
  BMC_BLOCKS,
  BMC_BLOCKS_BY_STEPS_ORDER,
};